export default {"src":"/_next/static/media/OPT-Primary-Black-min.0b6c5ce0.svg","height":75,"width":353,"blurWidth":0,"blurHeight":0};